module.exports = __webpack_public_path__ + "static/assets/7f42732a199a5805900db6631669117d.gif";